<!--
  Copyright (c) MobiFactory. All rights reserved.
  This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
  See LICENSE.txt file in the project root for full license information.
-->

<template>
  <el-select
    :model-value="selectedUserId"
    :placeholder="$t('UserSelect.Placeholder')"
    :clearable="clearable"
    filterable
    :filter-method="filterUsers"
    @change="onSelectionChange"
  >
    <el-option v-for="user in filteredUsers" :key="user.id" :value="user.id" :label="user.name"></el-option>
  </el-select>
</template>

<script>
import { defineComponent } from "vue";
import usersApi from "../../api/user/users";

export default defineComponent({
  name: "CrmUserSelect",

  props: {
    modelValue: {
      type: String,
      default: null,
    },
    sellerOnly: {
      type: Boolean,
      default: false,
    },
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["update:modelValue", "selectionChanged"],

  /**
   * Gets the component data
   * @returns {object} Component data
   */
  data() {
    return {
      users: null,
      filteredUsers: null,
    };
  },

  computed: {
    selectedUserId: {
      /**
       * Gets selectedUserId
       * @returns {string} - the selected user identifier
       */
      get: function () {
        return this.modelValue;
      },
    },
  },

  /**
   * When component is mounted
   * @returns {Promise}
   */
  async mounted() {
    await this.loadUsers();
    this.filterUsers("");
  },

  methods: {
    /**
     * On option selected
     * @param {string} userId - selected user id
     */
    onSelectionChange(userId) {
      this.$emit("update:modelValue", userId);
      this.$emit("selectionChanged");
      this.filterUsers("");
    },

    /**
     * Filters users
     * @param {string} searchText - search text
     */
    filterUsers(searchText) {
      if (!searchText) {
        this.filteredUsers = this.users;
      }

      this.filteredUsers = this.users.filter((u) => {
        if (u.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) {
          return true;
        }
      });
    },

    /**
     * Loads the users
     */
    async loadUsers() {
      let result = await usersApi.getUsers();
      if (result.isSuccess) {
        let selection = result.data.filter((u) => !u.isDeleted);
        if (this.sellerOnly) {
          selection = selection.filter((u) => u.isSeller || u.id === this.modelValue);
        }

        this.users = selection.sort((a, b) => a.name.localeCompare(b.name));
      }
    },
  },
});
</script>
